import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    refresh: false,
    experienceDetailsRefresh: false,
    educationDetailsRefresh: false,
    familyDetailsRefresh: false,
    addressDetailsRefresh: false, 
    financialDetailsRefresh : false,
    dematAccountDetailsRefresh: false,
    insuranceDetailsRefresh: false,
    kycDetailsRefresh: false  
}

export const userprofileRefreshReducerSlice = createSlice({
    name: 'user/userProfileRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setExperienceDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setEducationDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setFamilyDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setAddressDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setFinancialDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setDematDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setInsuranceDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setKYCDetailsRefresh: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
})

export const { setRefresh, setExperienceDetailsRefresh,setEducationDetailsRefresh, setFamilyDetailsRefresh, setAddressDetailsRefresh, setFinancialDetailsRefresh, setInsuranceDetailsRefresh, setDematDetailsRefresh,setKYCDetailsRefresh } = userprofileRefreshReducerSlice.actions;
export default userprofileRefreshReducerSlice.reducer